import { SVGProps, Ref, forwardRef } from 'react';

export const HeartOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.998 6.83 6.851 5.193c-1.159-1.655-2.59-1.97-3.6-1.714C2.218 3.74 1.4 4.628 1.4 5.967c0 1.007.728 2.153 2.254 3.446 1.271 1.077 2.846 2.05 4.344 2.951 1.498-.9 3.073-1.874 4.344-2.95 1.526-1.294 2.254-2.44 2.254-3.447 0-1.213-.795-2.129-1.87-2.417-1.023-.274-2.437.01-3.581 1.643zm0 7.167-.288-.173C4.403 11.843 0 9.204 0 5.967 0 2.372 4.112.61 7.056 3.307c.331.303.648.663.942 1.083q.444-.63.945-1.08c2.943-2.66 7.053-.755 7.053 2.657 0 3.237-4.404 5.876-7.71 7.857z"
                fill="currentColor"
            />
        </g>
    </svg>
));
HeartOutlinedSize16Glyph.displayName = 'HeartOutlinedSize16Glyph';
